import React, { Suspense, lazy, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useParams, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import SiteWidgets from './components/SiteWidgets';
import { ROUTES, getServiceDetailRoute } from './constants/routes';

const Home = lazy(() => import('./pages/Home'));
const Services = lazy(() => import('./pages/Services'));
const About = lazy(() => import('./pages/About'));
const Contact = lazy(() => import('./pages/Contact'));
const Impressum = lazy(() => import('./pages/Impressum'));
const Datenschutz = lazy(() => import('./pages/Datenschutz'));
const ServiceDetailPage = lazy(() => import('./pages/ServiceDetailPage'));

const LegacyServiceRedirect: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  if (!id) {
    return <Navigate to={ROUTES.SERVICES} replace />;
  }
  return <Navigate to={getServiceDetailRoute(id)} replace />;
};

const ScrollToTopOnRouteChange: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);

  return null;
};

function App() {
  return (
    <Router>
      <ScrollToTopOnRouteChange />
      <div className="app-container" style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Header />
        <main style={{ flex: 1 }}>
          <Suspense fallback={<div style={{ minHeight: '55vh' }} aria-busy="true" />}>
            <Routes>
              <Route path={ROUTES.HOME} element={<Home />} />
              <Route path={ROUTES.SERVICES} element={<Services />} />
              <Route path={ROUTES.SERVICE_DETAIL} element={<ServiceDetailPage />} />
              <Route path={ROUTES.ABOUT} element={<About />} />
              <Route path={ROUTES.CONTACT} element={<Contact />} />
              <Route path={ROUTES.IMPRESSUM} element={<Impressum />} />
              <Route path={ROUTES.DATENSCHUTZ} element={<Datenschutz />} />
              <Route path="/services" element={<Navigate to={ROUTES.SERVICES} replace />} />
              <Route path="/service/:id" element={<LegacyServiceRedirect />} />
              <Route path="/about" element={<Navigate to={ROUTES.ABOUT} replace />} />
              <Route path="/contact" element={<Navigate to={ROUTES.CONTACT} replace />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
        <SiteWidgets />
      </div>
    </Router>
  );
}

export default App;
